import { useLingui } from "@lingui/react/macro";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { useAppForm } from "~/components/ui/form";
import { parseValidationErrors } from "~/lib/errors";
import { useTRPC } from "~/trpc/client";
import { type AuthSignUpInput, authSignUpSchema } from "./sign-up.schema";

export function useAuthSignUpForm({
	defaultValues,
}: {
	defaultValues?: Partial<AuthSignUpInput>;
} = {}) {
	const { t } = useLingui();
	const trpc = useTRPC();
	const navigate = useNavigate();

	const authSignUpMutation = useMutation(
		trpc.auth.signup.mutationOptions({
			async onSuccess() {
				navigate({ to: "/manager" });
			},
		}),
	);

	return useAppForm({
		defaultValues: {
			emailAddress: "",
			userName: "",
			password: "",
			languageCode: navigator.language ? navigator.language.slice(0, 2) : "en",
			publisherID: "",
			secretCode: "",
			...defaultValues,
		},
		canSubmitWhenInvalid: true,
		validators: {
			onSubmit: authSignUpSchema,
			onSubmitAsync: async ({ value }) => {
				try {
					await authSignUpMutation.mutateAsync(value);
				} catch (e) {
					return parseValidationErrors(e, t`Something went wrong.`);
				}
			},
		},
	});
}
